<section class="section-title">
    <div class="section-title-image">
        <img class="user-image" src="assets/img/user.png" />
    </div>

    <div class="section-title-text">
        <h1 i18n="@@join_title">Richiesta permesso di transito</h1>
        <p *ngIf="ownerName"> gestore: {{ownerName}} </p>
    </div>

</section>


<section *ngIf="invalidOwnerUid">

    <div fxLayout="row" fxLayoutAlign="center end">
        <h3 style="padding-top: 100px;" i18n="@@join_invalid_data">I dati inseriti non sono validi</h3>
    </div>

</section>

<section *ngIf="requestCreated">

    <div fxLayout="row" fxLayoutAlign="center end">
        <h3 style="padding-top: 100px;" i18n="@@join_request_created_success">La richiesta è stata inviata con successo
        </h3>
    </div>

</section>

<section *ngIf="requestCreationError">

    <div fxLayout="row" fxLayoutAlign="center end">
        <h3 style="padding-top: 100px;" i18n="@@join_request_creation_error">Si è verificato un errore nella creazione
            della richiesta, verificare i dati inseriti e riprovare più tardi
        </h3>
    </div>

</section>


<section *ngIf="showRequestForm">
    <form [formGroup]="joinForm">
        <table class="simple-table user-add-table">
            <tr>
                <td width="200px" class="text-dark" i18n="@@join_first_name">Nome</td>
                <td>
                    <input id="first-name-input" formControlName="firstname" [(ngModel)]="firstname" />
                </td>
            </tr>

            <tr>
                <td width="200px" class="text-dark" i18n="@@join_last_name">Cognome</td>
                <td>
                    <input id="last-name-input" formControlName="lastname" [(ngModel)]="lastname" />
                </td>
            </tr>


            <tr>
                <td width="200px" height="80px" class="text-dark" i18n="@@join_email">Email</td>
                <td>
                    <input id="email-input" formControlName="email" [(ngModel)]="email" />
                </td>
            </tr>


            <tr>
                <td width="200px" height="80px" class="text-dark" i18n="@@join_licensePlate">Targa</td>
                <td>
                    <input id="licensePlate-input" formControlName="licensePlate" [(ngModel)]="licensePlate" />
                </td>
            </tr>

            <tr>
                <td width="200px" height="80px" class="text-dark" i18n="@@join_phoneNumber">Numero di telefono</td>
                <td>
                    <select formControlName="prefix" style="width: 25%;" [(ngModel)]="prefix">
                        <option *ngFor="let prefix of prefixes" [value]="prefix.value">
                            {{prefix.text}}
                        </option>
                    </select>
                    <input formControlName="phoneNumber" type="text" style="width: 75%;" [(ngModel)]="phoneNumber" />
                </td>

            </tr>



            <!-- </table> -->

            <tr>
                <td width="200px" height="80px" class="text-dark" i18n="@@join_dates">Date richiesta transito</td>
                <td>



                    <div id="datesDiv" class="date-wrapper">

                        <!-- <br> -->

                        <div id="fromDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@join_start_date">
                                Data di inizio:
                            </p>
                            <input id="from-datepicker-input" [readonly]=true [matDatepicker]="fromDatepicker"
                                value="{{ startDate }}" [formControl]="fromFormControl">
                            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #fromDatepicker></mat-datepicker>
                        </div>

                        <div id="toDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@join_expiration_date">
                                Data di fine:
                            </p>
                            <input id="to-datepicker-input" [readonly]=true [matDatepicker]="toDatepicker"
                                value="{{ expirationDate  }}" [formControl]="toFormControl">
                            <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #toDatepicker></mat-datepicker>
                        </div>

                        <br>

                    </div>

                    <!-- <table class="simple-table"> -->


                </td>
            </tr>


            <tr>
                <td width="200px" class="text-dark" i18n="@@join_operator">
                    Operatore
                </td>
                <td>
                    <select id="operator-select" formControlName="operator" [(ngModel)]="operator" (change)="operatorSelected($event)">
                        <option [ngValue]="alias" *ngFor="let alias of aliases">{{alias.publicName}}</option>
                    </select>
                    <div *ngIf="operatorChangeLoading" style="margin-top: 8px;">
                        <app-loading-screen [showtext]="false" style="height: 30px;"></app-loading-screen>
                    </div>
                </td>
            </tr>

                        <tr>
                <td width="200px" class="text-dark" i18n="@@join_type">
                    Tipologia permesso
                </td>
                <td>
                    <select id="type-select" formControlName="type" [(ngModel)]="permissionType" (change)="permissionTypeSelected($event)">
                        <option [ngValue]="type" *ngFor="let type of requestTypesList">{{type.name}}</option>
                    </select>
                </td>
            </tr>

            <tr *ngIf="permissionType && permissionType.fileNames && permissionType.fileNames.length > 0">
                <td width="200px" class="text-dark" i18n="@@join_file">
                    Carica file
                </td>
                <td>
                    <div *ngIf="permissionType && permissionType.fileNames && permissionType.fileNames.length > 0">
                        <div *ngFor="let fname of permissionType.fileNames; let i = index">
                            <label>{{fname}}</label><br>
                            <input type="file" accept=".jpg,.jpeg,.png,.bmp,.pdf,.doc,.docx" (change)="onFileSelected($event, fname)"><br>
                            <span *ngIf="selectedFiles[fname] && selectedFiles[fname].fileName">
                                {{ selectedFiles[fname].fileName }}.{{ selectedFiles[fname].fileExt }}
                            </span>
                            <br><br>
                        </div>
                    </div>

                    <div *ngIf="!permissionType || !permissionType.fileNames || permissionType.fileNames.length === 0">
                        <ng-container i18n="@@join_file_none">Nessun file richiesto</ng-container><br><br>
                    </div>

                    <ng-container i18n="@@join_file_max_size">Ogni file non deve essere più grande di 3.00 MB</ng-container>
                    <br>
                    <ng-container i18n="@@join_file_types">Tipi ammessi sono : .jpg .jpeg .png .bmp .pdf .doc .docx</ng-container>
                </td>
            </tr>

            <tr>
                <td width="200px" class="text-dark" i18n="@@join_notes">Note</td>
                <td>
                    <input id="notes-input" formControlName="notes" [(ngModel)]="notes" />
                </td>
            </tr>


        </table>

        <br>
        <br>

        <a (click)="createRequest()" class="button user-add-button">
            <ng-container i18n="@@join_create_request">Invia richiesta</ng-container>
            <span>
                <fa-icon icon="paper-plane"></fa-icon>
            </span>
        </a>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="wrongPhoneNumberError"
            i18n="@@join_phoneNumberError">
            Numero di telefono non valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="firstnameError"
            i18n="@@join_firstnameError">
            Inserire un nome valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="lastnameError" i18n="@@join_lastnameError">
            Inserire un cognome valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="emailError" i18n="@@join_emailError">
            Inserire un indirizzo email valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="licencePlateError"
            i18n="@@join_licencePlateError">
            La targa inserita non è valida </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="notesError" i18n="@@join_notesError">
            Le note inserite non sono valide</p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="missingFileError"
            i18n="@@join_missingFileError">
            È necessario caricare tutti i file richiesti</p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="invalidDatesError" i18n="@@join_invalid_dates_error">
            Le date inserite non sono valide</p>


        <p class="text-small text-error margin-top-10 display-inline" *ngIf="dateOver2100Error" i18n="@@join_end_date_too_far">
            La data di fine non può superare l'anno 2100</p>

    </form>

</section>

<app-loading-screen #joinloader [showtext]="false"></app-loading-screen>